<template>
  <div class="mpay-layout__error-message">

    <span v-if="validationError">
      <v-alert class="mx-0 my-0 px-0 py-0" :value="true" type="error">
        Validation error.<br/>
        Please check validation error messages.
      </v-alert>
    </span>

    <span v-if="customErrorMessage">
      <v-alert class="mx-0 my-0 px-0 py-0" :value="true" type="error">
        {{customErrorMessage}}
      </v-alert>
    </span>

    <span v-else-if="serverError">
      <v-alert class="mx-0 my-0 px-0 py-0" :value="true" type="error">
        {{messagePrefix}} Server error.<br/>Please try again later.
      </v-alert>
    </span>

    <span v-else-if="validationErrors">
      <v-alert class="px-0 py-0 mx-0 my-0" :value="true" type="error" >
        <span v-if="validationErrors.length === 0">Bad request. Please try again later.</span>
        <span v-else-if="validationErrors.length === 1">
          <span v-if="validationErrors[0].field">
            {{ startCase(validationErrors[0].field) }}:
          </span>
          {{ validationErrors[0].message }}
        </span>
        <span v-else>
          Validation errors:<br/>
          <ul>
            <li v-for="validationError in validationErrors" :key="validationError.field">
              <span v-if="validationError.field">
                {{ startCase(validationError.field) }}:
              </span>
              {{ validationError.message }}
            </li>
          </ul>
        </span>
      </v-alert>
    </span>

    <span v-else-if="serverApplicationNotAvailable">
      <v-alert class="px-0 py-0 mx-0 my-0" :value="true" type="error">
        {{messagePrefix}} Application Server is not available.<br/>Please try again later.
      </v-alert>
    </span>

    <span v-else-if="serverNotAvailable">
      <v-alert class="mx-0 my-0 px-0 py-0" :value="true" type="error">
        {{messagePrefix}} Remote Server is not available.<br/>Please try again later.
      </v-alert>
    </span>

    <span v-else-if="resourceNotFound">
      <v-alert class="mx-0 my-0 px-0 py-0" :value="true" type="error">
        {{messagePrefix}} Resource not found.<br/>Please try again later.
      </v-alert>
    </span>

    <span v-else-if="serverStatusUnexpected">
      <v-alert class="mx-0 my-0 px-0 py-0" :value="true" type="error">
        {{messagePrefix}} Unexpected server status: {{serverStatusUnexpected}}.
        <br/>Please try again later.
      </v-alert>
    </span>

    <span v-else-if="unauthorized">
      <v-alert class="mx-0 my-0 px-0 py-0" :value="true" type="error">
        {{messagePrefix}} This action is not allowed.
        <br/>Please contact Application administrator.
      </v-alert>
    </span>

    <v-layout v-else-if="serverReturnedNothing" justify-center>
      <span class="title mx-0 my-0 px-0 py-0">
        <span>{{messagePrefix}} No results</span>
      </span>
    </v-layout>

    <template v-else-if="loginFailed">
      <span>Wrong Login name or password</span>
    </template>

  </div>
</template>

<script>
import startCase from 'lodash.startcase';

export default {
  props: {
    error: { required: false },
    component: { type: String, required: false },
    login: { type: Boolean, required: false, default: false },
    serverReturnedNothing: { type: Boolean, required: false, default: false },
    validationError: { required: false },
    customErrorMessage: { type: String, required: false },
  },

  data: () => ({
    validationErrors: '',
    serverError: '',
    serverNotAvailable: '',
    serverApplicationNotAvailable: '',
    serverStatusUnexpected: '',
    resourceNotFound: '',
    loginFailed: '',
    unauthorized: '',
  }),

  computed: {
    messagePrefix() {
      return this.component ? `${this.component}: ` : '';
    },
  },

  methods: {
    init() {
      this.reset();
      if (this.error) {
        if (this.error.response) {
          const status = this.error.response.status;
          if (status === 400) {
            this.validationErrors = this.extractValidationErrors(this.error);
          } else if (status === 401) {
            if (this.login) {
              // login failed
              this.loginFailed = true;
            } else {
              // potentially token expired, permission error to be handled
              this.$store.dispatch('logout');
            }
          } else if (status === 403) {
            this.unauthorized = true;
          } else if (status === 500) {
            // runtime error
            this.serverError = this.error;
          } else if (status === 504) {
            // proxy can't access backend
            this.serverApplicationNotAvailable = this.error;
          } else if (status === 404) {
            this.resourceNotFound = this.error;
          } else {
            // server status to be handled
            this.serverStatusUnexpected = status;
          }
        } else {
          // connection refused or timed out
          this.serverNotAvailable = this.error;
        }
      }
    },
    reset() {
      this.validationErrors = '';
      this.serverError = '';
      this.serverNotAvailable = '';
      this.serverApplicationNotAvailable = '';
      this.serverStatusUnexpected = '';
      this.resourceNotFound = '';
      this.loginFailed = '';
      this.unauthorized = '';
    },
    extractValidationErrors(e) {
      if (e.response && e.response.data && e.response.data.errorCode === 'VALIDATION_FAILURE') {
        return e.response.data.errors;
      }
      return [];
    },
    startCase(value) {
      return startCase(value);
    },
  },

  watch: {
    error() {
      this.init();
    },
  },

  mounted() {
    this.init();
  },
};
</script>

<style>
  .mpay-layout__error-message .v-alert {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/MPayErrorMessage.vue